// File: src/pages/HomePage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import FeaturedPuppies from '../components/FeaturedPuppies';
import PetAdoptionFeedback from '../components/PetAdoptionFeedback';
import WhyChooseUs from '../components/WhyChooseUs';
import GlobalDeliverySuccess from '../components/GlobalDeliverySuccess';
import '../styles/HomePage.css';
import worker from '../resources/team1.jpg';
import worker1 from '../resources/team1.jpg';
import worker2 from '../resources/team3.jpg';
import worker3 from '../resources/team4.jpg';


interface PetExpert {
  id: number;
  name: string;
  role: string;
  specialty: string;
  experience: string;
  keyPoints: string[];
  avatar: string;
}

const HomePage: React.FC = () => {
  const petExperts: PetExpert[] = [
    {
      id: 1,
      name: "Dr. Emily Rodriguez",
      role: "Canine Veterinarian",
      specialty: "Puppy Health & Nutrition",
      experience: "12 years",
      keyPoints: [
        "Specializes in puppy vaccinations",
        "Nutritional counseling for dogs",
        "Behavioral training expert"
      ],
      avatar: worker
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Dog Behavior Specialist",
      specialty: "Puppy Training & Socialization",
      experience: "9 years",
      keyPoints: [
        "Rescue dog rehabilitation",
        "Puppy socialization programs",
        "Obedience training certified"
      ],
      avatar: worker1
    },
    {
      id: 3,
      name: "Sarah Johnson",
      role: "Breed Adoption Counselor",
      specialty: "Matching Puppies with Families",
      experience: "7 years",
      keyPoints: [
        "Specializes in breed matching",
        "Puppy temperament testing",
        "Adoption transition specialist"
      ],
      avatar: worker2
     }
    // {
    //   id: 4,
    //   name: "David Wilson",
    //   role: "Senior Canine Care Expert",
    //   specialty: "Post-Adoption Puppy Care",
    //   experience: "14 years",
    //   keyPoints: [
    //     "Puppy vaccination schedules",
    //     "House-training techniques",
    //     "Puppy-proofing homes"
    //   ],
    //   avatar: worker3
    // }
  ];

  return (
    <div className="home-page"><br/><br/><br/>
      {/* Hero Section - Unchanged */}
      <section className="hero-section1">
        <div className="hero-overlay1" />
        <div className="container">
          <div className="hero-content1">
            <div className="hero-text1">
              <h1 className="hero-title1">Perfect pups for your family</h1>
              <p className="hero-subtitle1">Find Your Forever Companion Here</p>
              <div className="hero-buttons1">
                <Link to="/Pets" className="btn btn-primary">
                  See Available Puppies
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Puppies Section */}
      <section className="featured-section">
        <div className="container">
          <FeaturedPuppies />
        </div>
      </section>

      {/* Global Delivery Success Section */}
      <section className="featured-section">
        <div className="container">
          <GlobalDeliverySuccess />
        </div>
      </section>

      {/* Dog Experts Section - Redesigned */}
      <section className="dog-experts-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Canine Care Team</h2>
            <p>Specialists dedicated to puppy health, training, and successful adoptions</p>
          </div>
          
          <div className="experts-container">
            {petExperts.map(expert => (
              <div className="expert-card" key={expert.id}>
                <div className="expert-avatar">
                  <img src={expert.avatar} alt={expert.name} />
                  <div className="expert-badge">
                    <i className="fas fa-paw"></i>
                  </div>
                </div>
                <div className="expert-info">
                  <h3>{expert.name}</h3>
                  <div className="expert-role">{expert.role}</div>
                  <div className="expert-specialty">{expert.specialty}</div>
                  <div className="expert-experience">{expert.experience} experience</div>
                  
                  <div className="expert-key-points">
                    <ul>
                      {expert.keyPoints.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

   

 
      <section className="adoption-stories">
        <div className="container">
          <PetAdoptionFeedback summaryMode={true} />
        </div>
      </section>


      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <WhyChooseUs />
        </div>
      </section>

      {/* Puppy Adoption Process - Redesigned */}
      <section className="adoption-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Puppy Adoption Journey</h2>
            <p>Simple steps to bringing your new best friend home</p>
          </div>
          
          <div className="process-steps">
            <div className="step">
              <div className="step-icon">
                <div className="icon-circle">1</div>
                <i className="fas fa-dog"></i>
              </div>
              <h3>Find Your Pup</h3>
              <p>Browse our available puppies and find your perfect match</p>
            </div>
            
            <div className="step">
              <div className="step-icon">
                <div className="icon-circle">2</div>
                <i className="fas fa-file-alt"></i>
              </div>
              <h3>Apply Online</h3>
              <p>Complete our simple puppy adoption application</p>
            </div>
            
            <div className="step">
              <div className="step-icon">
                <div className="icon-circle">3</div>
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Meet Your Puppy</h3>
              <p>Visit to meet your potential new furry friend</p>
            </div>
            
            <div className="step">
              <div className="step-icon">
                <div className="icon-circle">4</div>
                <i className="fas fa-home"></i>
              </div>
              <h3>Welcome Home</h3>
              <p>Finalize paperwork and bring your new pup home!</p>
            </div>
          </div>
          
          <div className="process-cta">
            <Link to="/pages/how-it-works" className="btn btn-primary">
              Start Your Adoption Journey
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;